<template>
  <div>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css"
      integrity="sha512-iBBXm8fW90+nuLcSKlbmrPcLa0OT92xO1BIsZ+ywDWZCvqsWgccV3gFoRBv0z+8dLJgyAHIhR35VZc2oM/gI1w=="
      crossorigin="anonymous" referrerpolicy="no-referrer" />
    <v-app-bar color="primary" dense fixed>
      <v-toolbar-title>
        <img height="52" :src="logoImg" alt="RLP" style="vertical-align: middle" id="logoImg" />
      </v-toolbar-title>
      <v-toolbar-content>

      </v-toolbar-content>
    </v-app-bar>

    <v-row>
      <v-col sm="12" md="12" lg="12">
        <v-row align="center" justify="center" dense>
          <v-col sm="12" md="6" lg="6" class="pa-10">

            <v-card class="containerbox">
              <v-card-title class="justify-center primary--text">Sign in to RLP</v-card-title>  
              <v-card-text align="center" >
                <div>This workspace allows you to sign in with business account. </div>
                <div>Please contact administrator if you have trouble signing in.</div>
              </v-card-text>       
              <v-card-actions class="justify-center pb-10" >
              <v-btn  v-if="!isAuthenticated" class="pl-10 pr-10" color="primarytext"  @click="login" outlined><v-icon class="pr-3">mdi mdi-microsoft</v-icon>   Sign-in with Microsoft</v-btn>     
              <!-- <button c v-if="!isAuthenticated" color="primarytext" outlined 
              @click="login"> Login with Microsoft</button> -->
            </v-card-actions>

            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import utility from '@/shared/utility';
import encryptUtility from '../utility/js/encrypt-utility';
import authHeader from "../../services/auth-header";
//import { msalConfig } from '@/msal.config';
import jwt_decode from "jwt-decode";
import { APPCODE } from '../utility/js/constants-utility';
import commonApiService from '../common/js/common-api-service';
export default {
  data() {
    return {
      isAuthenticated: false,
      user: null,
      authInProgress: false,
      logoImg: require("@/assets/images/kstdata.png"),
      ipData: [],
      userId: "",
      urlArray: [],
      uralArrayPageAction: [],
      permission: [],
      cookieTime: 60 * 60 * 24 * 365,
      // accessTokenRequest: {
      //   scopes: ['api://bc4a2062-ef4b-44e8-a685-f45ff393efe9/Expense.Write', 'api://bc4a2062-ef4b-44e8-a685-f45ff393efe9/Expense.Read']
      // }
    };
  },
  async mounted() {
     // Handle any redirect response on component creation
    this.getIP()   
  },
  async created() {
    if (this.authInProgress) return;
    this.authInProgress = true;
    try {
      const response = await this.$msal.handleRedirectPromise();      
        if (response && !encryptUtility.localStorageDecrypt('isAuthenticated')) {
          encryptUtility.localStorageEncrypt("isAuthenticated", "true");
          this.isAuthenticated = true;
          // Handle successful login response
          // Store user info       
          await this.loginApiCall(response);  // Call your API with the response// Redirect to /home after login
        }
        else{
          localStorage.clear();
          sessionStorage.clear();
          //this.login();
        } 
    } catch (error) {
      this.authInProgress = false;
    }
  },


  methods: {
    getIP() {
      this.axios.get("https://ipapi.co/json/").then((response) => {
        this.ipData = [];
        this.ipData = response.data;
      });
    },

    async login() {
      try {
        // Handle the Azure AD redirect response
        const response = await this.$msal.handleRedirectPromise();        
        if (response) {
          this.isAuthenticated =  true;
          this.$router.replace('/home');
          // Call your API after successful login          
          await this.loginApiCall(response);
          this.user = response.account; // Store logged-in user information

        } else {        
          // If no response, check if the user is already authenticated
          const accounts = this.$msal.getAllAccounts();
          if (accounts.length === 0) {          
            // If no accounts, start the redirect login flow
            await this.$msal.loginRedirect(this.accessTokenRequest);
            //  await this.$msal.loginRedirect(msalConfig.accessTokenRequest);
          } else {           
            // User is already logged in, update the state
            this.user = accounts[0]; // Set the first account
            this.isAuthenticated = true;
            encryptUtility.localStorageEncrypt("isAuthenticated", "true");
            this.$router.replace('/home');  // Set the first account
            // Redirect to /home if user is already authenticated
          }
        }
      } catch (error) {
        console.error('Error during login:', error);
      }
    },

    loginApiCall(responseValue) {
      // const accounts = this.$msal.getAllAccounts();
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };    
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let loginModel = {
        Email: responseValue?.idTokenClaims?.preferred_username,
        Password: "QiGN16anvAZR+h49oTmNKgh90hVCpNYpwCIXn22KKoQjvWdkhbaRWXuVoJ5xnJv7",
        Appcode: APPCODE,        
        SystemInfo: JSON.stringify(this.ipData),
        Jwt:responseValue.accessToken
      };
      this.axios
        .post("ap/login_val", loginModel)
        
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let userIP = this.ipData?.ip;          
            localStorage.clear();
            encryptUtility.localStorageEncrypt("printerIP", userIP);
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            encryptUtility.localStorageEncrypt("showNav", true.toString());
            this.$store.commit("ConfigModule/showNav", true);
            let responseData = response.data.body;
            encryptUtility.localStorageEncrypt("userID", responseData.UserId.toString());
            this.userId = responseData.UserId;
            encryptUtility.localStorageEncrypt("fname", responseData.FName.toString());
            encryptUtility.localStorageEncrypt("lname", responseData.LName.toString());
            encryptUtility.localStorageEncrypt("email", responseData.Email.toString());
            encryptUtility.localStorageEncrypt("installId", responseData.InstallId.toString());          
            encryptUtility.localStorageEncrypt("Token", responseData.Jwt);
            
            let printerData = JSON.parse(responseData?.Printer);
            if (responseData?.Printer?.length !== 0 && responseData?.Printer !== null && responseData?.Printer !== undefined) {
            
              if (printerData[0]?.p_name !== null && printerData[0]?.p_name !== "") {
                encryptUtility.localStorageEncrypt("primaryCheck", "true");
                encryptUtility.localStorageEncrypt("primaryName", printerData[0]?.p_name);
                encryptUtility.localStorageEncrypt("primaryLabelSize", printerData[0]?.p_size);
                encryptUtility.localStorageEncrypt("primaryPrinterType", printerData[0]?.p_type);
                
              }
              if (printerData[0]?.s_name !== null && printerData[0]?.s_name !== "") {
                encryptUtility.localStorageEncrypt("secondaryCheck", "true");
                encryptUtility.localStorageEncrypt("secondaryName", printerData[0]?.s_name);
                encryptUtility.localStorageEncrypt("secondaryLabelSize", printerData[0]?.s_size);
                encryptUtility.localStorageEncrypt("secondaryPrinterType", printerData[0]?.s_type);
              }
              if (printerData[0]?.default_printer !== null && printerData[0]?.default_printer !== "") {
                encryptUtility.localStorageEncrypt("defaultCheck", "true");
                encryptUtility.localStorageEncrypt("defaultName", printerData[0]?.default_printer);
              }
              encryptUtility.localStorageEncrypt("printerID", printerData[0]?.printer_id?.toString());
            }
            authHeader(responseData.Jwt);
            
            
            encryptUtility.localStorageEncrypt("isAuthenticated", "true");
      
            this.decoded = jwt_decode(responseData.Jwt);
            //encryptUtility.localStorageEncrypt("JWTExp", JSON.stringify(this.decoded.exp * 1000));
             encryptUtility.localStorageEncrypt("JWTExp", JSON.stringify(this.decoded.exp));  
            encryptUtility.localStorageEncrypt("themeCode", JSON.stringify(responseData.ThemeCode));
            if (responseData.ThemeCode == "Dark") {
              this.$vuetify.theme.dark = true;
              encryptUtility.localStorageEncrypt("theme", JSON.stringify(this.$vuetify.theme.dark));
            } else if (responseData.ThemeCode == "Light") {
              this.$vuetify.theme.dark = false;
              encryptUtility.localStorageEncrypt("theme", JSON.stringify(this.$vuetify.theme.dark));
            } else {
              this.$vuetify.theme.dark = false;
              encryptUtility.localStorageEncrypt("theme", JSON.stringify(this.$vuetify.theme.dark));
            }
            this.$router.push("/home");            
            this.getMenuList();
            this.createUniqSystemName();
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.password = "";
          this.errorMessage = error.message;
        });
    },
    getMenuList() {      
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`ap/user_menu?user_id=${this.userId}`)
        .then((response) => {
          
          if (
            response.status == 200 &&
            response.data !== undefined &&
            response.data.body !== undefined &&
            response.data.body.message !== undefined &&
            response.data.body.message !== undefined &&
            response.data.body.message !== null
          ) {
            let menuResponseData = response.data.body.message;
            if (menuResponseData !== "" && menuResponseData !== undefined && menuResponseData !== null) {
              this.permission = JSON.parse(menuResponseData).Menus;
              //To Travarse Group level
              this.permission?.forEach((element) => {
                //To Travarse sub group
                element?.Childs.forEach((childelement) => {
                  //To Traverse between groups
                  childelement.ChildOfChilds?.forEach((childofchildelement) => {
                    //TO Traverse between Pages and get the URl
                    this.urlArray.push(childofchildelement.Url);
                    // To get the URLs in Page Level
                    //To Check if Child of child is present or not
                    if (childofchildelement?.ChildOfChildOfChilds != undefined) {
                      childofchildelement?.ChildOfChildOfChilds.forEach((childofchildofchildelement) => {
                        //Push the Values inside a new Array
                        this.urlArray.push(childofchildofchildelement.Url);
                      });
                    }
                  });
                });
              });
              // To remove empty values
              this.urlArray = this.urlArray.filter((item) => item);
              //To Show the user Profile Page;
              this.urlArray.push("user-profile");
              this.urlArray.push("printer-settings");
              this.urlArray.push("report-issue");
              this.urlArray.push("report-issue-admin");
              this.urlArray.push("app-role-copy");
              this.urlArray.push("app-role-add-copy");
              this.urlArray.push("app-role-edit-copy");
              this.urlArray.push("test");
              this.urlArray.push("home")
              // To store the values in localstorage
              encryptUtility.localStorageEncrypt("Url", JSON.stringify(this.urlArray));
            } else {
              let Alert = {
                type: "error",
                isShow: true,
                message: "User is not associated with any role or do not have permission to menu.",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {

              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    createUniqSystemName() {
      if (
        this.$cookies.get("uniqueSystemName") !== "" &&
        this.$cookies.get("uniqueSystemName") !== undefined &&
        this.$cookies.get("uniqueSystemName") !== null
      ) {
        this.uniqSystemName = this.$cookies.get("uniqueSystemName");
        this.getPrinterDetails();
      }
    },
    async getPrinterDetails() {
      let printerObj = {
        json: JSON.stringify({
          user_id: parseInt(this.userId),
          pass: 1,
          printer_id: "",
          p_name: "",
          p_size: "",
          p_type: "",
          s_name: "",
          s_size: "",
          s_type: "",
          ip: "",
          default_printer: "",
          machine_name: this.uniqSystemName,
        }),
      };
      let showMessage = false;
      let printerData = await commonApiService.userPrinterPreferences("post", printerObj, showMessage);
      if (printerData.message !== "NA") {
        if (printerData?.length !== 0 && printerData !== null && printerData !== undefined) {
          if (printerData[0]?.p_name !== null && printerData[0]?.p_name !== "") {
            encryptUtility.localStorageEncrypt("primaryCheck", "true");
            encryptUtility.localStorageEncrypt("primaryName", printerData[0]?.p_name);
            encryptUtility.localStorageEncrypt("primaryLabelSize", printerData[0]?.p_size);
            encryptUtility.localStorageEncrypt("primaryPrinterType", printerData[0]?.p_type);
          }
          if (printerData[0]?.s_name !== null && printerData[0]?.s_name !== "") {
            encryptUtility.localStorageEncrypt("secondaryCheck", "true");
            encryptUtility.localStorageEncrypt("secondaryName", printerData[0]?.s_name);
            encryptUtility.localStorageEncrypt("secondaryLabelSize", printerData[0]?.s_size);
            encryptUtility.localStorageEncrypt("secondaryPrinterType", printerData[0]?.s_type);
          }
          if (printerData[0]?.default_printer !== null && printerData[0]?.default_printer !== "") {
            encryptUtility.localStorageEncrypt("defaultCheck", "true");
            encryptUtility.localStorageEncrypt("defaultName", printerData[0]?.default_printer);
          }
          encryptUtility.localStorageEncrypt("printerID", printerData[0]?.printer_id?.toString());
        }
      }
    },

  },

};
</script>
<style scoped>
.ucs-logo {
  max-width: 70%;
  max-height: 90%
}

.login-card {
  width: 90%;
  height: 80%;
  margin-top: 2%;
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 2%;
}

.forgotpass {
  cursor: pointer;
}

</style>
